module.exports = __webpack_public_path__ + "img/google-logo-carre.65feb6d4.png";